export enum GenderEnum {
  MALE = 1,
  FEMALE = 2,
  NA = 3
}
